module.exports = __webpack_public_path__ + "static/new-commands-70c8a17db3e969239bd097ed65964bf7.svg";